import { Image, Pressable, Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { SUPPORTED_LOCALES } from '../../../../i18n'
import type { RewardItem } from './types'

interface RewardItemCardProps {
  item: RewardItem
  i18nPrefix: string
  onPress: (item: RewardItem) => void
}

export function RewardItemCard({ item, i18nPrefix, onPress }: RewardItemCardProps) {
  const { t, i18n } = useTranslation()
  const lang = i18n.language === 'sv' ? 'sv' : 'en'
  return (
    <Pressable
      onPress={() => onPress(item)}
      accessibilityRole="button"
      accessibilityLabel={item.name[lang] || item.name.en}
      className="w-[calc(50%_-_6px)] lg:w-[calc(33.333%_-_8px)] 2xl:w-[calc(50%_-_6px)] 3xl:w-[calc(33.333%_-_8px)] overflow-hidden rounded-lg border border-border"
    >
      <View className="relative h-28 w-full overflow-hidden lg:h-36">
        {item.imageUrl ? (
          <Image source={{ uri: item.imageUrl }} resizeMode="cover" style={{ width: '100%', height: '100%' }} />
        ) : (
          <View className="h-full w-full bg-canvas-primary" />
        )}
        {!item.active ? (
          <View className="absolute right-2 top-2 rounded-md bg-canvas-card/90 px-2 py-1">
            <Text className="text-xs font-semibold text-primary">{t(`${i18nPrefix}.inactive`)}</Text>
          </View>
        ) : SUPPORTED_LOCALES.some((l) => !item.name[l].trim()) ? (
          <View className="absolute right-2 top-2 rounded-md bg-canvas-card/90 px-2 py-1">
            <Text className="text-xs font-semibold text-warning">{t(`${i18nPrefix}.translationIncomplete`)}</Text>
          </View>
        ) : null}
      </View>
      <View className="gap-1 p-3">
        <Text className="text-sm font-semibold text-primary" numberOfLines={1}>{item.name[lang] || item.name.en}</Text>
        <Text className="text-xs text-secondary" numberOfLines={2}>{item.description[lang] || item.description.en}</Text>
      </View>
    </Pressable>
  )
}
